/**
 * Empaque obligatorio por grupo (caja personalizada): /cart/change.js + /cart/add.js
 */
(function () {
  function getStrings() {
    return (
      window.box2goPackagingStrings || {
        required: 'Elige empaque para cada caja personalizada.',
        updateError: 'No se pudo actualizar el empaque. Intenta de nuevo.',
      }
    );
  }

  function cartJsUrl() {
    var base = window.routes && window.routes.cart_url ? window.routes.cart_url.replace(/\/$/, '') : '/cart';
    return base + '.js';
  }

  function getGruposNeedingPackaging(cart) {
    var items = cart.items || [];
    var needsPiece = {};
    items.forEach(function (item) {
      var p = item.properties || {};
      var gid = p.box2go_grupo != null && String(p.box2go_grupo).trim() !== '' ? String(p.box2go_grupo) : '';
      if (!gid) return;
      if (String(p._box2go_packaging) !== '1') needsPiece[gid] = true;
    });
    var hasPkg = {};
    items.forEach(function (item) {
      var p = item.properties || {};
      var gid = p.box2go_grupo != null && String(p.box2go_grupo).trim() !== '' ? String(p.box2go_grupo) : '';
      if (!gid) return;
      if (String(p._box2go_packaging) === '1') hasPkg[gid] = true;
    });
    var missing = [];
    Object.keys(needsPiece).forEach(function (gid) {
      if (!hasPkg[gid]) missing.push(gid);
    });
    return missing;
  }

  function clearPackagingInvalidClass() {
    document.querySelectorAll('[data-box2go-packaging-select].box2go-packaging--invalid').forEach(function (el) {
      el.classList.remove('box2go-packaging--invalid');
    });
  }

  window.Box2GoPackagingValidateCheckout = function () {
    return fetch(cartJsUrl())
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        clearPackagingInvalidClass();
        var missing = getGruposNeedingPackaging(cart);
        if (missing.length === 0) return true;
        var msg = getStrings().required;
        var gid = missing[0];
        var target = null;
        document.querySelectorAll('[data-box2go-packaging-select]').forEach(function (el) {
          if (el.getAttribute('data-box2go-grupo') === gid) target = el;
        });
        if (typeof alert === 'function') alert(msg);
        if (target) {
          target.classList.add('box2go-packaging--invalid');
          if (typeof target.focus === 'function') target.focus();
        }
        return false;
      })
      .catch(function () {
        if (typeof alert === 'function') alert(getStrings().updateError);
        return false;
      });
  };

  function packagingLineIndexesDescending(cart, gidStr) {
    var lines = [];
    (cart.items || []).forEach(function (item, idx) {
      var p = item.properties || {};
      if (String(p.box2go_grupo) === gidStr && String(p._box2go_packaging) === '1') {
        lines.push(idx + 1);
      }
    });
    lines.sort(function (a, b) {
      return b - a;
    });
    return lines;
  }

  function removePackagingForGrupo(gidStr) {
    function removeNext() {
      return fetch(cartJsUrl())
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          var lines = packagingLineIndexesDescending(cart, gidStr);
          if (lines.length === 0) return;
          var line = lines[0];
          var cfg = fetchConfig();
          cfg.headers = Object.assign({}, cfg.headers, { 'X-Requested-With': 'XMLHttpRequest' });
          cfg.body = JSON.stringify({ line: line, quantity: 0 });
          return fetch(window.routes.cart_change_url, cfg).then(function () {
            return removeNext();
          });
        });
    }
    return removeNext();
  }

  function addPackagingVariant(variantId, gidStr, cajaLabel) {
    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', '1');
    fd.append('properties[box2go_grupo]', gidStr);
    fd.append('properties[Caja]', cajaLabel || '');
    fd.append('properties[_box2go_packaging]', '1');

    var config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = fd;

    return fetch(window.routes.cart_add_url, config).then(function (r) {
      return r.json();
    });
  }

  function publishCartUpdate() {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'box2go-packaging' });
    }
  }

  function onSelectChange(selectEl) {
    var gid = selectEl.getAttribute('data-box2go-grupo');
    var label = selectEl.getAttribute('data-box2go-caja-label') || '';
    var vid = (selectEl.value || '').trim();
    selectEl.classList.remove('box2go-packaging--invalid');
    selectEl.disabled = true;

    removePackagingForGrupo(String(gid))
      .then(function () {
        if (!vid) {
          publishCartUpdate();
          return null;
        }
        return addPackagingVariant(vid, String(gid), label);
      })
      .then(function (parsed) {
        if (parsed && parsed.status) {
          if (typeof alert === 'function') alert(getStrings().updateError);
          return;
        }
        publishCartUpdate();
      })
      .catch(function () {
        if (typeof alert === 'function') alert(getStrings().updateError);
      })
      .finally(function () {
        selectEl.disabled = false;
      });
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-box2go-packaging-select]')) return;
    onSelectChange(t);
  });

  document.addEventListener('shopify:section:load', clearPackagingInvalidClass);
})();
